import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash-es';
export const unsubscribeOnDestroy = function (target, observables) {
    const ngOnDestroy = target.prototype.ngOnDestroy;
    target.prototype.ngOnDestroy = function () {
        if (observables === undefined) {
            _.each(this, (subscription) => {
                if (subscription instanceof Subscription) {
                    subscription.unsubscribe();
                }
            });
        }
        else {
        }
        if (ngOnDestroy !== undefined) {
            ngOnDestroy.apply(this, arguments);
        }
    };
};
//# sourceMappingURL=unsubscribe-on-destroy.func.js.map